import React, { useState } from 'react'
import PropTypes from 'prop-types';

import ShortTermLeasingInfoModal from './ShortTermLeasingInfoModal'
import ShortTermLeasingFormModal from './ShortTermLeasingFormModal'

export const ShortTermLeasingModal = ({ materialId, isOpen, onClose }) => {
    const [isMarketoForm, setIsMarketoForm] = useState(false)
    const handleClose = ()=> {
        onClose();
        setIsMarketoForm(false)
    }
    if(!isOpen || materialId?.length === 0) return null
    return (
        !isMarketoForm ?
            <ShortTermLeasingInfoModal
                materialId={materialId}
                setIsMarketoForm={setIsMarketoForm}
                onClose={handleClose}
            />
            : <ShortTermLeasingFormModal
                materialId={materialId}
                setIsMarketoForm={setIsMarketoForm}
                onClose={handleClose}
            />

    )
}
export default ShortTermLeasingModal;

ShortTermLeasingModal.propTypes = {
  materialId: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
};
